import { render } from "./ThongTinTuyen.vue?vue&type=template&id=4675a062&scoped=true"
import script from "./ThongTinTuyen.vue?vue&type=script&lang=js"
export * from "./ThongTinTuyen.vue?vue&type=script&lang=js"

import "./ThongTinTuyen.vue?vue&type=style&index=0&id=4675a062&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4675a062"]])

export default __exports__